export enum Permission {
	SEALORD = "sealord",
	INVOICES_WAR = "invoices-war",
	INVOICES_CYBERRISK = "invoices-cyberrisk",
	POLICIES_WAR = "policies-war",
	POLICIES_CYBERRISK = "policies-cyberrisk",
	CYBERRISK_PROFILE = "cyberrisk-profile",
	UPDATE_REQUESTS_ORGANISATIONS = "update-requests-organisations",
	UPDATE_REQUESTS_POLICIES = "update-requests-policies",
	UPDATE_REQUESTS_VESSELS = "update-requests-vessels",
	USERS_MANAGEMENT = "users-management",
	ORGANISATION_DIVIDENDS = "organisation-dividends",
	DIVIDENDS_HANDLER = "dividends-handler",
	TRIPADMIN = "tripadmin",
	CIRCULARS = "circulars",

	CLAIMS_CYBERRISK = "claims-cyberrisk",
	// CLAIMS_WAR = "claims-war",
	// CLAIMS_UPLOAD = "claims-upload",
	CLAIMS_HANDLER = "claims-handler",
	CYBERRISK_HANDLER = "cyberrisk-handler",
	AGM = "agm",
}

export const global: {
	key: Permission;
	label: string;
	uwr?: boolean;
	sealord?: boolean;
	defaultChecked?: boolean;
}[] = [
	{
		key: Permission.TRIPADMIN,
		label: "TripAdmin",
		uwr: true,
		defaultChecked: true,
	},
	{
		key: Permission.CIRCULARS,
		label: "Circulars & files",
		uwr: true,
		defaultChecked: true,
	},
	{
		key: Permission.CLAIMS_HANDLER,
		label: "Claims Handler",
		sealord: true,
	},
	{
		key: Permission.CYBERRISK_HANDLER,
		label: "Cyberrisk Handler",
		sealord: true,
	},
	{
		key: Permission.DIVIDENDS_HANDLER,
		label: "Dividends Handler",
		sealord: true,
	},
];

export const organisation: {
	key: string;
	label: string;
	items: {
		key: Permission;
		label: string;
		needs?: Permission[];
	}[];
}[] = [
	{
		key: "war",
		label: "War",
		items: [
			{
				key: Permission.POLICIES_WAR,
				label: "Policies",
			},
			{
				key: Permission.INVOICES_WAR,
				label: "Invoices",
			},
		],
	},
	{
		key: "cyberrisk",
		label: "Cyberrisk",
		items: [
			{
				key: Permission.CYBERRISK_PROFILE,
				label: "Profile",
			},
			{
				key: Permission.CLAIMS_CYBERRISK,
				label: "Claims",
			},
			{
				key: Permission.POLICIES_CYBERRISK,
				label: "Policies",
			},
			{
				key: Permission.INVOICES_CYBERRISK,
				label: "Invoices",
			},
		],
	},
	// {
	//     key: "claims",
	//     label: "Claims",
	//     items: [
	//         {
	//             key: Permission.CLAIMS_CYBERRISK,
	//             label: "Cyberrisk Claims",
	//         },
	//         {
	//             key: Permission.CLAIMS_WAR,
	//             label: "War Claims",
	//         },
	//         {
	//             key: Permission.CLAIMS_UPLOAD,
	//             label: "Upload Claims Documents",
	//         },
	//     ],
	// },
	{
		key: "update-requests-organisations",
		label: "Update requests",
		items: [
			{
				key: Permission.UPDATE_REQUESTS_ORGANISATIONS,
				label: "Organisations (+dividends)",
			},
			{
				key: Permission.UPDATE_REQUESTS_POLICIES,
				label: "Policies",
				needs: [Permission.POLICIES_WAR],
			},
			{
				key: Permission.UPDATE_REQUESTS_VESSELS,
				label: "Vessels",
				needs: [Permission.POLICIES_WAR],
			},
		],
	},
	{
		key: "organisation",
		label: "Organisation Profile",
		items: [
			{
				key: Permission.USERS_MANAGEMENT,
				label: "User Management",
			},
			{
				key: Permission.ORGANISATION_DIVIDENDS,
				label: "Dividends",
			},
			{
				key: Permission.AGM,
				label: "Annual General Meeting",
			},
		],
	},
];

export enum PermissionSet {
	MEMBER = "member",
	MEMBER_WAR = "member-war",
	CYBERRISK_INSURED = "cyberrisk-insured",
	BROKER = "broker",
	IT = "it",
	CO_INSURED = "co-insured",
	MORTGAGEE = "mortgagee",
	THIRD_PARTY = "third-party",
}

export const sets: Record<
	PermissionSet,
	{
		title: string;
		preset: Permission[];
	}
> = {
	[PermissionSet.MEMBER]: {
		title: "Member",
		preset: [
			Permission.POLICIES_WAR,
			Permission.POLICIES_CYBERRISK,
			Permission.INVOICES_WAR,
			Permission.INVOICES_CYBERRISK,
			Permission.CYBERRISK_PROFILE,
			Permission.UPDATE_REQUESTS_ORGANISATIONS,
			Permission.UPDATE_REQUESTS_POLICIES,
			Permission.UPDATE_REQUESTS_VESSELS,
			Permission.TRIPADMIN,
			Permission.CIRCULARS,
		],
	},
	[PermissionSet.MEMBER_WAR]: {
		title: "War Member",
		preset: [
			Permission.POLICIES_WAR,
			Permission.INVOICES_WAR,
			Permission.UPDATE_REQUESTS_ORGANISATIONS,
			Permission.UPDATE_REQUESTS_POLICIES,
			Permission.UPDATE_REQUESTS_VESSELS,
			Permission.TRIPADMIN,
			Permission.CIRCULARS,
		],
	},
	[PermissionSet.CYBERRISK_INSURED]: {
		title: "Cyberrisk Insured",
		preset: [
			Permission.POLICIES_WAR,
			Permission.POLICIES_CYBERRISK,
			Permission.INVOICES_CYBERRISK,
			Permission.CYBERRISK_PROFILE,
			Permission.UPDATE_REQUESTS_POLICIES,
			Permission.CIRCULARS,
		],
	},
	[PermissionSet.BROKER]: {
		title: "Broker",
		preset: [
			Permission.POLICIES_WAR,
			Permission.POLICIES_CYBERRISK,
			Permission.INVOICES_WAR,
			Permission.INVOICES_CYBERRISK,
			Permission.CYBERRISK_PROFILE,
			Permission.UPDATE_REQUESTS_ORGANISATIONS,
			Permission.UPDATE_REQUESTS_POLICIES,
			Permission.UPDATE_REQUESTS_VESSELS,
			Permission.TRIPADMIN,
			Permission.CIRCULARS,
		],
	},
	[PermissionSet.IT]: {
		title: "IT personell",
		preset: [Permission.CYBERRISK_PROFILE],
	},
	[PermissionSet.CO_INSURED]: {
		title: "Co-insured",
		preset: [],
	},
	[PermissionSet.MORTGAGEE]: {
		title: "Mortgagee",
		preset: [Permission.POLICIES_WAR],
	},
	[PermissionSet.THIRD_PARTY]: {
		title: "3rd party",
		preset: [Permission.CIRCULARS],
	},
};
